export const PLAN_TYPE = {
    Freemium: 'Free',
    Premium: 'Premium'
};
export const PLAN_NAME = {
    Essentials: 'Essentials',
    Premium: 'Premium'
};
export const FREEMIUM_LIMITATION = 3;
export const TEAM_FREMIUM_LIMITATION = 2;
export const TEAM_FREMIUM_LIMITATION_V3 = 2;
export const UPGRADE_PREMIUM = {
    team: 'Team',
    questionRegistry: 'Question Registry',
    investorSatisfaction: 'Investor Satisfaction',
    event: 'Event',
    announcement: 'Annoucement',
    sentiment: 'sentiment',
    datapoint: 'datapoint',
    integration: 'integration'
};
export const ERROR_MESSAGE_FOR_LOCKED_TEAM_FREEMIUM = 'You are locked to login into this company. Please contact company admin.';
export const checkIsFreemiumPlan = (plan) => PLAN_TYPE.Freemium === plan;

export const checkIsPremiumPlan = (plan) => PLAN_TYPE.Premium === plan;

export const checkFreemiumAndItemsLengthGreaterThanFreemiumLimitation = (plan, count) =>
    checkIsFreemiumPlan(plan) && count < FREEMIUM_LIMITATION;
export const checkItemsLengthGreaterThanFreemiumTeamLimitation = (count) => count < TEAM_FREMIUM_LIMITATION;
export const checkItemsLengthGreaterThanFreemiumTeamLimitationV2 = (count) => count > TEAM_FREMIUM_LIMITATION;
export const checkItemsLengthGreaterThanFreemiumTeamLimitationV3 = (count) => count <= TEAM_FREMIUM_LIMITATION_V3;
export const checkItemsLengthGreaterThanFreemiumTeamLimitationV4 = (count) => count === TEAM_FREMIUM_LIMITATION;
